import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {alertTypes, useAlerts} from '../ui/alert';

import {
  getCandidatosEnOportDuck,
  getCandidatosEnOportThunk,
  desactivarCandidatoThunk,
  desactivarCandidatoDuck,
  guardarEdicionOportDuck,
  guardarEdicionOportThunk,
  generarReposicionDuck,
  generarReposicionThunk,
  getMotivosDescarteDuck,
  getMotivosDescarteThunk,
  getResumenEtapasThunk,
  getResumenEtapasDuck,
  enviarMailInicioDuck,
  enviarMailInicioThunk,
  getUsuariosForSelectThunk,
  getUsuariosForSelectDuck,
} from './duck';

import {
  constants,
  responseSelector,
  log,
  prepareDatosAuxOptions,
  parseJwt,
} from '../utils/utils';

import {EditarOportunidadView} from './EditarOportunidadView';
import {getOportunidadDuck, getOportunidadThunk} from './duck';
import {
  oportunidadEstadoOptions,
  oportunidadOptionsByValue,
} from '../utils/constants';
import {todosOption} from './EditarOportunidadShared';

const queryString = require('query-string');

const filtroOrigenPostulacionOptions = [
  todosOption,
  {value: 'selector', label: 'Selector'},
  {value: 'portal', label: 'Portal'},
];

function EditarOportunidadV2({history, match, test, token}) {
  const dispatch = useDispatch();

  const modelGetCandidatosEnOport = useSelector(
    state => state.getCandidatosEnOport,
  );

  const modelUsuarios = useSelector(state => state.getUsuariosForSelect);

  const modelGetOportunidad = useSelector(state => state.getOportunidad);

  const modelGuardarEdicionOport = useSelector(
    state => state.guardarEdicionOport,
  );
  const modelDesactivarCandidato = useSelector(
    state => state.desactivarCandidato,
  );
  const modelGenerarReposicion = useSelector(state => state.generarReposicion);
  const modelGetMotivosDescarte = useSelector(
    state => state.getMotivosDescarte,
  );
  const modelGetResumenEtapas = useSelector(state => state.getResumenEtapas);

  const modelEnviarMailInicio = useSelector(state => state.enviarMailInicio);

  const [oportunidadId, setOportunidadId] = useState();
  const [candidatos, setCandidatos] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [isModalCambioEtapaShown, setIsModalCambioEtapaShown] = useState(false);
  const [etapasOptions, setEtapasOptions] = useState();
  const [oportunidad, setOportunidad] = useState();
  const [oportunidadLoadStatus, setOportunidadLoadStatus] = useState('IDLE');
  const [etapasById, setEtapasById] = useState();
  const [selectedCandidato, setSelectedCandidato] = useState();
  const [isModalConfirmarDesactivarShown, setIsModalConfirmarDesactivarShown] =
    useState();
  const [estadoOption, setEstadoOption] = useState();
  const estadosOptions = oportunidadEstadoOptions;
  const [isModalConfirmarReposicionShown, setIsModalConfirmarReposicionShown] =
    useState(false);
  const [incluirCandidatos, setIncluirCandidatos] = useState(false);

  const {submitAlert, setTopAlert, topAlert} = useAlerts();
  const descarteAlertDefaultValue = {
    text: null,
    type: null,
    title: null,
    closable: false,
  };
  const [descarteAlert, setDescarteAlert] = useState(descarteAlertDefaultValue);

  const [etapasEnOportunidad, setEtapasEnOportunidad] = useState();
  const [conteoPorEtapa, setConteoPorEtapa] = useState();

  const [motivosOptions, setMotivosOptions] = useState();

  const [isModalNotasShown, setIsModalNotasShown] = useState(false);

  const [candidatoIdNumerico, setCandidatoIdNumerico] = useState();

  const [userIdNumerico, setUserIdNumerico] = useState();

  const [filtroNombre, setFiltroNombre] = useState('');

  const [filtroEtapaOption, setFiltroEtapaOption] = useState(todosOption);
  const [filtroEtapaOptions, setFiltroEtapaOptions] = useState();

  const [filtroMotivoDescarteOption, setFiltroMotivoDescarteOption] =
    useState(todosOption);
  const [filtroMotivoDescarteOptions, setFiltroMotivoDescarteOptions] =
    useState();

  const [filtroOrigenPostulacionOption, setFiltroOrigenPostulacionOption] =
    useState(todosOption);

  const [accion, setAccion] = useState();

  const [usuarioOptions, setUsuarioOptions] = useState([]);
  const [usuariosCierre, setUsuariosCierre] = useState([]);

  useEffect(() => {
    setFiltroMotivoDescarteOptions([
      todosOption,
      ...(motivosOptions?.length ? motivosOptions : []),
    ]);
  }, [motivosOptions]);

  useEffect(() => {
    setFiltroEtapaOptions([
      todosOption,
      ...(etapasOptions?.length ? etapasOptions : []),
    ]);
  }, [etapasOptions]);

  const [correoTopAlert, setCorreoTopAlert] = useState({
    text: null,
    type: null,
    title: null,
    closable: false,
  });
  const [correoEnviado, setCorreoEnviado] = useState(false);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetMotivosDescarte);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getMotivosDescarteDuck.actions.clear());
    }

    if (data) {
      setMotivosOptions(prepareDatosAuxOptions(data.items));
      dispatch(getMotivosDescarteDuck.actions.clear());
    }
  }, [modelGetMotivosDescarte]);

  useEffect(() => {
    if (token?.raw) {
      const decodedToken = parseJwt(token.raw);
      setUserIdNumerico(decodedToken?.idNumerico);
    }
  }, [token]);

  const hideModalNotas = () => {
    setCandidatoIdNumerico(null);
    setIsModalNotasShown(false);
  };

  const showModalNotas = () => {
    setIsModalNotasShown(true);
  };

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelEnviarMailInicio);

    if (error) {
      setCorreoTopAlert({
        title: null,
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(enviarMailInicioDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      setCorreoTopAlert({
        title: null,
        text: message,
        type: alertTypes.success,
        closable: false,
      });

      setCorreoEnviado(true);

      dispatch(enviarMailInicioDuck.actions.clear());
    }
  }, [modelEnviarMailInicio]);

  function enviarMailInicio(oportunidad) {
    dispatch(
      enviarMailInicioThunk({
        userToken: token.raw,
        oportunidadId: oportunidad.idNumerico,
      }),
    );
  }

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetCandidatosEnOport);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getCandidatosEnOportDuck.actions.clear());
    }

    if (data) {
      setCandidatos(data.items);
      setTotalResults(data.total);
      dispatch(getCandidatosEnOportDuck.actions.clear());
    }
  }, [modelGetCandidatosEnOport]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetResumenEtapas);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getResumenEtapasDuck.actions.clear());
    }

    if (data) {
      setEtapasEnOportunidad(data.etapasEnOportunidad);
      setConteoPorEtapa(data.conteoPorEtapa);
      dispatch(getResumenEtapasDuck.actions.clear());
    }
  }, [modelGetResumenEtapas]);

  const prepareEtapasOptions = etapas => {
    const mEtapasOptions = etapas.map(etapa => ({
      value: etapa.idNumerico,
      label: etapa.descripcion,
    }));

    return mEtapasOptions;
  };

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetOportunidad);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getOportunidadDuck.actions.clear());
    }

    if (data) {
      setOportunidad(data.oportunidad);
      setEtapasOptions(
        prepareEtapasOptions(data.oportunidad.etapasWithDescription),
      );
      const mEtapasByIds = {};
      data.oportunidad.etapasWithDescription?.forEach(etapa => {
        mEtapasByIds[etapa.idNumerico] = etapa;
      });
      setEtapasById(mEtapasByIds);
      setEstadoOption(oportunidadOptionsByValue[data.oportunidad.estado]);
      setOportunidadLoadStatus('LOADED');

      dispatch(
        getUsuariosForSelectThunk({
          userToken: token.raw,
        }),
      );

      dispatch(getOportunidadDuck.actions.clear());
    }
  }, [modelGetOportunidad]);

  const onAvanzarError = errorMessage => {
    setDescarteAlert({
      text: errorMessage,
      type: alertTypes.danger,
      closable: false,
    });
    hideModalCambioEtapa();
  };

  const onAvanzarSuccess = () => {
    setDescarteAlert({
      text: 'Avance de etapa exitoso',
      type: alertTypes.success,
      closable: false,
    });

    handlePage(0);
    dispatch(
      getResumenEtapasThunk({
        userToken: token.raw,
        oportunidadId,
      }),
    );
    hideModalCambioEtapa();
  };

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGuardarEdicionOport);

    log('modelGuardarEdicionOport.useEffect');

    if (error) {
      log('modelGuardarEdicionOport.useEffect.error');

      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(guardarEdicionOportDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      log('modelGuardarEdicionOport.useEffect.success');

      setTopAlert({
        text: message,
        type: alertTypes.success,
        closable: false,
      });

      dispatch(
        getOportunidadThunk({
          idNumerico: oportunidadId,
          userToken: token.raw,
        }),
      );

      dispatch(guardarEdicionOportDuck.actions.clear());
    }
  }, [modelGuardarEdicionOport]);

  useEffect(() => {
    const {message, httpStatus, error, errorMessage} = responseSelector(
      modelDesactivarCandidato,
    );

    log('modelDesactivarCandidato.useEffect');

    if (error) {
      log('modelDesactivarCandidato.useEffect.error');

      setDescarteAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      hideModalConfirmarDesactivar();

      dispatch(desactivarCandidatoDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      log('modelDesactivarCandidato.useEffect.success');

      setDescarteAlert({
        text: message,
        type: alertTypes.success,
        closable: false,
      });

      handlePage(0);

      hideModalConfirmarDesactivar();

      dispatch(desactivarCandidatoDuck.actions.clear());
    }
  }, [modelDesactivarCandidato]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGenerarReposicion);

    log('modelGenerarReposicion.useEffect');

    if (error) {
      log('modelGenerarReposicion.useEffect.error');

      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(generarReposicionDuck.actions.clear());
      hideModalConfirmarReposicion();
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      log('modelGenerarReposicion.useEffect.success');

      setTopAlert({
        text: message,
        type: alertTypes.success,
        closable: false,
      });

      dispatch(generarReposicionDuck.actions.clear());
      hideModalConfirmarReposicion();
      history.push(`/editarOportunidad/${data.reposicionOportId}`);
    }
  }, [modelGenerarReposicion]);

  useEffect(() => {
    log('matchParamsOportunidadId.useEffect');
    setOportunidadId(match.params.oportunidadId);
  }, [match.params.oportunidadId]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelUsuarios);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getUsuariosForSelectDuck.actions.clear());
    }

    if (data) {
      if (oportunidad.aCargoDe) {
        const idsNumericos = oportunidad.aCargoDe.map(row => row.usuarioId);
        const usuariosOptions = data?.data.filter(elem =>
          idsNumericos.includes(elem.value),
        );

        setUsuarioOptions(usuariosOptions);
      }

      if (oportunidad?.cierre?.conteoUsuarios) {
        const idsNumericos = oportunidad.cierre.conteoUsuarios.map(
          row => row.usuarioId,
        );
        const usuariosOptions = data?.data.filter(elem =>
          idsNumericos.includes(elem.value),
        );

        setUsuariosCierre(usuariosOptions);
      }

      dispatch(getUsuariosForSelectDuck.actions.clear());
    }
  }, [modelUsuarios]);

  useEffect(() => {
    log('oportunidadId.useEffect');

    if (oportunidadId) {
      log('oportunidadId.useEffect.insideIf');
      handlePage(0);

      dispatch(
        getMotivosDescarteThunk({
          userToken: token.raw,
        }),
      );
      dispatch(
        getResumenEtapasThunk({
          userToken: token.raw,
          oportunidadId,
        }),
      );
      dispatch(
        getOportunidadThunk({
          idNumerico: oportunidadId,
          userToken: token.raw,
        }),
      );
    }
  }, [oportunidadId]);

  function handlePage(page) {
    setActivePage(page);

    setCandidatos([]);

    const newUrlParams = {
      page: page + 1,
      limit: pageSize,
      nombre: filtroNombre,
      etapa: filtroEtapaOption.value,
      motivoDescarte: filtroMotivoDescarteOption.value,
      origenPostulacion: filtroOrigenPostulacionOption.value,
    };

    const newUrl = `${history.location.pathname}?${queryString.stringify(
      newUrlParams,
    )}`;

    history.replace(newUrl);

    const wsParams = {
      ...newUrlParams,
      oportunidadId,
    };
    dispatch(
      getCandidatosEnOportThunk({
        ...wsParams,
        userToken: token.raw,
      }),
    );
  }

  function hideModalCambioEtapa() {
    log('hideModalCambioEtapa');
    setIsModalCambioEtapaShown(false);
  }

  function showModalCambioEtapa() {
    log('showModalCambioEtapa');
    setIsModalCambioEtapaShown(true);
  }

  function hideModalConfirmarDesactivar() {
    setIsModalConfirmarDesactivarShown(false);
  }

  function showModalConfirmarDesactivar() {
    setIsModalConfirmarDesactivarShown(true);
  }

  function hideModalConfirmarReposicion() {
    setIsModalConfirmarReposicionShown(false);
  }

  function showModalConfirmarReposicion() {
    log('showModalConfirmarReposicion');
    setIsModalConfirmarReposicionShown(true);
  }

  function desactivarCandidato() {
    dispatch(
      desactivarCandidatoThunk({
        userToken: token.raw,
        candidatoIdNumerico: selectedCandidato.idNumerico,
        oportunidadIdNumerico: oportunidadId,
      }),
    );
  }

  function guardarEdicion() {
    dispatch(
      guardarEdicionOportThunk({
        userToken: token.raw,
        oportunidadIdNumerico: oportunidadId,
        estado: estadoOption?.value,
        usuariosCierre,
      }),
    );
  }

  function confirmarReposicion() {
    dispatch(
      generarReposicionThunk({
        userToken: token.raw,
        oportunidadIdNumerico: oportunidadId,
        incluirCandidatos,
      }),
    );
  }

  return (
    <EditarOportunidadView
      history={history}
      topAlert={topAlert}
      submitAlert={submitAlert}
      totalResults={totalResults}
      activePage={activePage}
      pageSize={pageSize}
      handlePage={handlePage}
      candidatos={candidatos}
      modelGetCandidatosEnOport={modelGetCandidatosEnOport}
      oportunidadId={oportunidadId}
      hideModalCambioEtapa={hideModalCambioEtapa}
      showModalCambioEtapa={showModalCambioEtapa}
      etapasOptions={etapasOptions}
      oportunidad={oportunidad}
      etapasById={etapasById}
      oportunidadLoadStatus={oportunidadLoadStatus}
      selectedCandidato={selectedCandidato}
      setSelectedCandidato={setSelectedCandidato}
      isModalCambioEtapaShown={isModalCambioEtapaShown}
      isModalConfirmarDesactivarShown={isModalConfirmarDesactivarShown}
      hideModalConfirmarDesactivar={hideModalConfirmarDesactivar}
      showModalConfirmarDesactivar={showModalConfirmarDesactivar}
      desactivarCandidato={desactivarCandidato}
      guardarEdicion={guardarEdicion}
      estadosOptions={estadosOptions}
      estadoOption={estadoOption}
      setEstadoOption={setEstadoOption}
      modelGuardarEdicionOport={modelGuardarEdicionOport}
      modelDesactivarCandidato={modelDesactivarCandidato}
      showModalConfirmarReposicion={showModalConfirmarReposicion}
      hideModalConfirmarReposicion={hideModalConfirmarReposicion}
      isModalConfirmarReposicionShown={isModalConfirmarReposicionShown}
      confirmarReposicion={confirmarReposicion}
      modelGenerarReposicion={modelGenerarReposicion}
      incluirCandidatos={incluirCandidatos}
      setIncluirCandidatos={setIncluirCandidatos}
      etapasEnOportunidad={etapasEnOportunidad}
      conteoPorEtapa={conteoPorEtapa}
      descarteAlert={descarteAlert}
      modelGetResumenEtapas={modelGetResumenEtapas}
      modelGetOportunidad={modelGetOportunidad}
      isModalNotasShown={isModalNotasShown}
      hideModalNotas={hideModalNotas}
      showModalNotas={showModalNotas}
      candidatoIdNumerico={candidatoIdNumerico}
      setCandidatoIdNumerico={setCandidatoIdNumerico}
      userIdNumerico={userIdNumerico}
      enviarMailInicio={enviarMailInicio}
      modelEnviarMailInicio={modelEnviarMailInicio}
      correoTopAlert={correoTopAlert}
      correoEnviado={correoEnviado}
      filtroNombre={filtroNombre}
      setFiltroNombre={setFiltroNombre}
      filtroEtapaOption={filtroEtapaOption}
      setFiltroEtapaOption={setFiltroEtapaOption}
      filtroEtapaOptions={filtroEtapaOptions}
      filtroMotivoDescarteOption={filtroMotivoDescarteOption}
      setFiltroMotivoDescarteOption={setFiltroMotivoDescarteOption}
      filtroMotivoDescarteOptions={filtroMotivoDescarteOptions}
      filtroOrigenPostulacionOption={filtroOrigenPostulacionOption}
      filtroOrigenPostulacionOptions={filtroOrigenPostulacionOptions}
      setFiltroOrigenPostulacionOption={setFiltroOrigenPostulacionOption}
      accion={accion}
      setAccion={setAccion}
      token={token}
      onAvanzarSuccess={onAvanzarSuccess}
      onAvanzarError={onAvanzarError}
      usuarioOptions={usuarioOptions}
      usuariosCierre={usuariosCierre}
      setUsuariosCierre={setUsuariosCierre}
    />
  );
}

export {EditarOportunidadV2};
